import React from 'react'
import { withContext } from 'ansok/components/common/withContext'
import { LocaleInterface } from 'types'

/**
 * Translated text output
 * Requires locale from context
 */
const Text: React.FunctionComponent<TextProps> = props => {
  const { locale, children, id, className, style, filters, html, wrap, ...params } = props
  let textProps

  // Translate
  const key = children.toString()
  let translation = ''
  try {
    translation = locale.translate(key, params) 
  } catch {
    console.log('this failed: ', key, params)
  }

  // Filter translation if filters provided
  if (filters) {
    (Array.isArray(filters) ? filters : [filters]).forEach(
      filter => translation = filter(translation),
    )
  }

  // Pass on props to text node
  textProps = {
    id,
    className,
    style,
  }

  // If html output set, add html prop
  if (html) {
    textProps.dangerouslySetInnerHTML = {
      __html: translation,
    }
  }

  return React.createElement(wrap, textProps, html ? null : translation)
}

Text.defaultProps = {
  html: false,
  wrap: 'span',
}

type TextProps = {
  locale: LocaleInterface,
  children?: React.ReactText,
  id?: string,
  className?: string,
  style?: object,
  filters?: TextFilterType | TextFilterType[],
  html?: boolean,
  wrap?: string,
  [key: string]: any,
}

type TextFilterType = (text: string) => string

export default withContext(Text)